/* eslint-disable import/first */
/* eslint-disable arrow-body-style */
export { BackendMode, backend, composedBackend, domlikeBackend, } from './backend';
export { CurrentWindowBackendContext } from './backend/current_window_backend_context';
export { EmptyBackendContext } from './backend/empty_backend';
export { EmptyComposedBackendContext } from './backend/empty_composed_backend';
export { Behavior, BehaviorBuilder, } from './behavior';
export { ClassList, StyleScopeManager } from './class_list';
export { Component, ComponentDefinition, } from './component';
export * as typeUtils from './component_params';
export { ComponentSpace, getDefaultComponentSpace } from './component_space';
export * as dataPath from './data_path';
export { DataGroup, NormalizedPropertyType, } from './data_proxy';
export * as dataUtils from './data_utils';
export { Element, StyleSegmentIndex } from './element';
export { ElementIterator, ElementIteratorType } from './element_iterator';
export { Event, EventBubbleStatus, MutLevel as EventMutLevel, EventPhase, } from './event';
export { FuncArr, safeCallback } from './func_arr';
export { DeepCopyKind, globalOptions, } from './global_options';
export { MutationObserver, MutationObserver as Observer } from './mutation_observer';
export * as mutationObserver from './mutation_observer';
export { NativeNode } from './native_node';
export { dumpElement, dumpElementToString, dumpSingleElementToString } from './node';
export { RelationType } from './relation';
export { triggerRender } from './render';
export { ParsedSelector } from './selector';
export { ShadowRoot, SlotMode } from './shadow_root';
export * as templateEngine from './template_engine';
export { TextNode } from './text_node';
export * as template from './tmpl';
export { TraitBehavior } from './trait_behaviors';
export { VirtualNode } from './virtual_node';
export { triggerWarning, dispatchError, addGlobalErrorListener, addGlobalWarningListener, removeGlobalErrorListener, removeGlobalWarningListener, } from './warning';
import { Component, } from './component';
import { getDefaultComponentSpace } from './component_space';
import { Event } from './event';
export const registerBehavior = (def) => {
    return getDefaultComponentSpace().defineBehavior(def);
};
export const registerElement = (def) => {
    return getDefaultComponentSpace().defineComponent(def);
};
export function createElement(tagName, compDef) {
    return Component.create(tagName, compDef || null);
}
export const triggerEvent = Event.triggerEvent;
export const triggerExternalEvent = Event.triggerExternalEvent;
//# sourceMappingURL=index.js.map